module.exports = __webpack_public_path__ + "imgs/website-white.c1b3336a8a761cb141d35af80fb950f1.svg";